/**
 * Type for sort directions
 *
 * DO NOT USE THESE FOR TEXT VALUES!
 */
export enum SortDirection {
  ASCENDING = '__ascending__',
  DESCENDING = '__descending__',
}

/**
 * CSS classes applied to <th /> to style properly when sorting is enabled
 */
export enum ThSortClass {
  ASCENDING = 'sort-ascending',
  DESCENDING = 'sort-descending',
}

/**
 * Types of sorting algorithms
 */
export enum SortType {
  ALPHABETICAL = 'alphabetical',
  NUMERIC = 'numeric',
  DEFAULT = ALPHABETICAL,
}

/**
 * This enum exists in order to have a central place where the names of all
 * data-* attributes can be found - in hopes of aiding documentation.
 *
 * data-* attributes place in the <th /> tag by the consumer to enable sorting,
 * specify sort type, specify sort value, and align text inside <th />
 */
export enum DataAttributeTh {
  // a string that will be used as the aria-label="" attribute
  // in the <th /> when overriding default values
  ARIA_LABEL_ASCENDING = 'data-aria-label-ascending',
  ARIA_LABEL_DESCENDING = 'data-aria-label-descending',

  // disables sorting of column - defaults to true
  // only a value of false will disable
  // empty value is default true
  SORT_DISABLED = 'data-sort-disabled',

  // values defined in SortType
  SORT_TYPE = 'data-sort-type',

  // value used to sort - useful if <td /> content is a date
  // and data-sort-value="unixTimestamp"
  SORT_VALUE = 'data-sort-value',

  // filtering attributes
  // a json string (array) of values on which the column can be filtered
  FILTER_VALUES_JSON = 'data-filter-values-json',

  // if set 'true' will allow multiple filters to be selected in each column
  FILTER_VALUES_MULTIPLE = 'data-filter-values-multiple',

  // used to create options in the sort <hp6-text-select />
  // and for aria-label="" attribute values
  TEXT_SELECT_LABEL_ASCENDING = 'data-text-select-label-ascending',
  TEXT_SELECT_LABEL_DESCENDING = 'data-text-select-label-descending',

  // will be used in aria-label and table-header-panel to describe the
  // how the column can be sorted
  TEXT_SORT_ASCENDING = 'data-text-sort-direction-ascending',
  TEXT_SORT_DESCENDING = 'data-text-sort-direction-descending',

  /**
   * data-* attributes below are only used internally in table
   * and require no documentation
   */

  // used to identify the <button /> that is created inside each <th />
  // also used in css styles
  BUTTON_IDENTIFIER = 'data-hp-table-th-button',

  // used only in css styles
  // 'data-text-align', // values - 'left' (default), 'center', 'right'
}

/**
 * These data-* attributes are used only in CSS styles and are not to be
 * consumed. These exist here for documentation purposes only
 */
export enum DocumentationOnly {
  // used in a <th /> to align text
  // possible values: "left" (default), "center", "right"
  'data-text-align',
}
